export const asNumber = (number, digits) => {
    return Number.parseFloat(number || '0').toFixed(digits)
}

export default asNumber;
